import React from 'react';
import MetricsTabel from './MetricsTabel';
import MetricsControlPanel from './MetricsControlPanel';

export const Metrics = () => {
  return (
    <div style={{overflow: 'overlay', width: '100%'}}>
      <div className={'metrics-container'}>
        <MetricsControlPanel/>
        <MetricsTabel/>
      </div>
    </div>
  );
};
